import { combineReducers } from "redux";
import PassesReducer from './PassesReducer';
import PartnerReducer from './PartnerReducer';
import paymentReducer from './paymentReducer';

const RootReducer = combineReducers({
    PassesReducer,
    PartnerReducer,
    paymentReducer
})

export default RootReducer;